import { usePartnerConfig } from '@hooks/usePartnerConfig';
import { useContext, useMemo } from 'react';
import { Context } from '@context/context';
import { IState } from '@context/stateModels';
import styles from './LegacyStepBar.module.scss';

// Thin progress bar shipped before #26994. Kept as the fallback rendered when the
// feature flag Onboarding.All.Stepbar is off, so the stepper can be rolled back in
// production without redeploying the frontend.
const LegacyStepBar = () => {
  const { state } = useContext<IState>(Context);
  const { partnerConfig } = usePartnerConfig();

  const partnerClass = useMemo(() => (partnerConfig?.partnerName ? styles.partnerStyles : ''), [partnerConfig]);

  const stepList = state.stepManager?.stepList ?? [];
  const actualStep = stepList.find(step => step.stepName === state.stepManager?.actualStep);
  const actualPosition = actualStep ? actualStep.stepNumber - 1 : 0;
  const barLength = stepList.length > 1 ? (actualPosition / (stepList.length - 1)) * 95 : 0;

  return (
    <div className={styles.barStep}>
      {barLength > 0 && (
        <div className={styles.barBase}>
          <div className={`${styles.bar} bar-length ${partnerClass}`} style={{ width: `${barLength}%` }} />
        </div>
      )}
    </div>
  );
};

export default LegacyStepBar;
